import React from 'react';
import {Link} from "react-router-dom";

import Icon from './Icon';

const Pagination = ({
            currentPage = 1, 
            pagesCount = 1, 
            paginationLength = 7, 
            link = false, 
            search = "", 
            className = "", 
            handleChangePage = () => {}
        }) => {
            
    currentPage = parseInt(currentPage);
    pagesCount = parseInt(pagesCount);
    paginationLength = parseInt(paginationLength);

    if ( currentPage < 1 ) {
        currentPage = 1;
    }
    if ( currentPage > pagesCount ) {
        currentPage = pagesCount;
    }


    // Si 1 seule page (voire 0) on n'affiche rien
    if ( pagesCount <= 1 ) {
        return null;
    }

    let pages = [];
    // Si on a moins de 7 pages, on les affiche toutes
    if ( pagesCount <= paginationLength ) {
        pages = Array.from({length: pagesCount}, (_, i) => i + 1)
    }
    // Sinon (on a au moins 8 pages)
    else {
        let middle = Math.floor((paginationLength - 1) / 2); // Page du milieu (utile dans les calculs qui suivent)

        // Dans les premières pages (besoin de ... à droite seulement)
        if ( currentPage < middle + 2 ) {
            pages = [
                ...Array.from({length: paginationLength - 2}, (_, i) => i + 1), 
                '...',
                pagesCount
            ];
        }
        // Dans les dernières pages (besoin de ... à gauche seulement)
        else if ( currentPage >= pagesCount - middle ) {
            pages = [
                1,
                '...',
                ...Array.from({length: paginationLength - 2}, (_, i) => i + pagesCount - paginationLength + 2 + 1)
            ];
        }
        // Au milieu (besoin de ... à gauche et à droite)        
        else {
            pages = [
                1,
                '...',
                ...Array.from({length: paginationLength - 4}, (_, i) => i + currentPage - middle + 2),
                '...',
                pagesCount
            ];
        }
    }

    // On affiche Précédent / Suivant si c'est pertinent
    let canPrevious = (currentPage > 1);
    let canNext = (currentPage < pagesCount);

    const handleClickPrevious = () => {
        handleChangePage((currentPage - 1), link);
    };
    const handleClickNext = () => {
        handleChangePage((currentPage + 1), link);
    };

    return (
        <div className={`pagination ${className}`}>
            <div className="pagination-btn-group ">
                {canPrevious && (
                    <Link to={`${link}${currentPage - 1 < 2 ? "" : "/" + (currentPage - 1)}${search}`}
                          onClick={() => handleClickPrevious()}
                          className="pagination-btn prev"
                    >
                        <Icon type="caret-left"/>
                    </Link>
                )}

                <div className={"pagination-number-container"}>
                    {pages.map((item, index) =>item === '...' ? (
                            <div className="pagination-btn hellip disable" key={`page_${index}`} />
                        )
                        : (
                            <Link
                                to={link + (item === 1 ? '' : '/' + item) + search}
                                key={`page_${index}`}
                                onClick={() => item === currentPage ? null : handleChangePage(item, link)}
                                className={`pagination-btn ${(item === currentPage) ? 'active' : ""}`}
                            >
                                {item}
                            </Link>
                        )

                    )}
                </div>

                {canNext && (
                    <Link to={`${link}/${currentPage + 1}${search}`}
                            onClick={() => handleClickNext()}
                            className="pagination-btn next"
                    >
                        <Icon type="caret-right"/>
                    </Link>
                )}


            </div>
        </div>
    )
};

export default Pagination;

